import { render, staticRenderFns } from "./DISCOBJECT.status.update.component.vue?vue&type=template&id=661f376c&"
import script from "./DISCOBJECT.status.update.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.status.update.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports